export const polyfill = Component => Component